import { createFileRoute, useNavigate } from "@tanstack/react-router";

import Button from "@/components/atoms/actions/Button";
import ProductGrid from "@/components/organisms/products/ProductGrid";

const Products = () => {
  const navigate = useNavigate();

  return (
    <div className="p-2">
      <h1 className="mb-4 text-2xl font-bold">Products</h1>
      <ProductGrid />

      <Button onClick={() => navigate({ to: "/product/create" })} label={"Create new Product"} />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/products")({
  component: Products,
});
